import { render } from "./long-insure-report.vue?vue&type=template&id=3df7c128&scoped=true&ts=true"
import script from "./long-insure-report.vue?vue&type=script&lang=ts"
export * from "./long-insure-report.vue?vue&type=script&lang=ts"

import "./long-insure-report.vue?vue&type=style&index=0&id=3df7c128&lang=stylus&scoped=true"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df7c128"]])

export default __exports__